export default __webpack_public_path__ + "static/media/grace-leaves.e818b6a2.png";